import { featuredBrandData } from './mocks'
import useFeaturedBrand from './useFeaturedBrand'


const useFeaturedBrandInfo = (slug: string): BrandsModule.FeaturedBrandInfo => {
  const featuredBrand = useFeaturedBrand()

  if (featuredBrand !== slug) {
    return null
  }

  return featuredBrandData[featuredBrand]?.featuredBrandInfo
}

export default useFeaturedBrandInfo
